import React from 'react';
import useAuthForms from '../hooks/useAuthForms';
import useIFrameMessage, { IFRAME_MESSAGE_TYPES } from '../hooks/useIFrameMessage';
import { useMarketplaceConfig } from '../queries/marketplace';

const AuthModalHandler = ({ children }: { children: React.ReactElement }) => {
  const { isHybrid } = useMarketplaceConfig();
  const { openRegisterForm, openLoginForm } = useAuthForms();

  useIFrameMessage(IFRAME_MESSAGE_TYPES.REQUIRE_AUTH, isHybrid ? openLoginForm : openRegisterForm);

  return children;
};

export default AuthModalHandler;
